module.exports = __webpack_public_path__ + "img/homepage-quick-links-boxes-arrows-hyundai.eb7bd7fe.png";